<template>
  <CFormGroup
    v-bind="{
      append, prepend, validFeedback, invalidFeedback,
      tooltipFeedback, description, wrapperClasses, class: computedClasses
    }"
    :style="wrapperAttrs.style"
    :class="wrapperAttrs.class"
  >
    <template #label>
      <slot name="label">
        <label v-if="label" :for="safeId" :class="labelClasses">
          {{label}}
        </label>
      </slot>
    </template>
    <template #input>
      <select
        v-bind="controlAttrs"
        :id="safeId"
        :class="inputClasses"
        @change="onSelect($event)"
      >
        <option v-if="placeholder" value="" selected hidden>
          {{placeholder}}
        </option>
        <template v-for="(option, key) in options" :key="key">
          <option
            v-if="typeof option === 'object'"
            :value="option.value"
            v-bind="option.attrs"
            :disabled="option.disabled"
            :selected="option.value === current"
            :data-key="key"
          >
            {{option.label || option.value}}
          </option>
          <option
            v-else
            :value="option"
            :selected="option === current"
            :data-key="key"
          >
            {{option}}
          </option>
        </template>
      </select>
    </template>
    <template v-for="slot in passSlots" #[slot]>
      <slot :name="slot"></slot>
    </template>
  </CFormGroup>
</template>

<script>
import * as allFormMixins from './form-mixins'
import { selectProps as props } from './form-props'
import CFormGroup from './CFormGroup.vue'
const { initialValue, ...mixinMap } = allFormMixins
const mixins = Object.values(mixinMap)
const SLOTS = ['prepend', 'prepend-content', 'append-content', 'append', 'label-after-input', 'valid-feedback', 'invalid-feedback', 'description']

export default {
  name: 'CSelect',
  inheritAttrs: false,
  components: { CFormGroup },
  mixins,
  props,
  emits: ['input', 'update:value', 'update:modelValue'],
  data () {
    return {
      state: initialValue(this) || undefined
    }
  },
  computed: {
    /** Vue 2 compared options against the `value` prop; v-model now arrives as modelValue */
    current () {
      return this.modelValue !== undefined ? this.modelValue : this.value
    },
    passSlots () {
      return SLOTS.filter((s) => this.$slots[s])
    },
    customSizeClass () {
      if (this.haveCustomSize && !this.haveWrapper) {
        return `${this.custom ? 'custom-select' : 'form-control'}-${this.size}`
      }
      return undefined
    },
    inputClass () {
      const standardClass = `form-control${this.plaintext ? '-plaintext' : ''}`
      return this.custom ? 'custom-select' : standardClass
    }
  },
  methods: {
    onSelect (e) {
      if (this.$attrs.multiple !== undefined && this.$attrs.multiple !== false) return
      const selected = e.target.selectedOptions[0]
      if (!selected) return
      const optionIndex = selected.dataset.key
      const option = this.options[optionIndex]
      if (option === undefined) return
      const value = option !== null && typeof option === 'object' && option.value !== undefined ? option.value : option
      this.state = value
      this.$emit('update:value', value, e)
      this.$emit('update:modelValue', value)
      this.$emit('input', value, e)
    }
  }
}
</script>
